module.exports = __webpack_public_path__ + "h5/img/f8.dad603c6.jpg";